module.exports = __webpack_public_path__ + "components/page-header/static/icon-caret-down--black-5c2c9a42d0ee6835fdfef88cf76b6592.svg";